<template>
  <!--彈出視窗-->
  <v-dialog v-model="alertInfo.visible" persistent :max-width="width">
    <v-card>
      <v-card-title class="headline">
        {{ alertInfo.title }}
      </v-card-title>
      <v-card-text>
        <span class="title">{{ alertInfo.content }}</span>
        <span v-if="alertInfo.showDate">
          <v-menu
            ref="showDateMenu"
            v-model="showDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                persistent-hint
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates"
              no-title
              range
              @change="changeDateMenu"
            ></v-date-picker>
          </v-menu>
        </span>
        <span v-if="alertInfo.showInput">          
          <v-text-field
            label="出貨單號"
            v-model="shippingNumber"
          ></v-text-field>

          <v-menu
            v-model="showDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="shippingDate"
                label="出貨日期"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="shippingDate"
              @input="showDateMenu = false"
            ></v-date-picker>
          </v-menu>
        </span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="alertInfo.showCancel"
          color="#ffb128"
          dark
          text
          @click="alertInfo.cancelEvent"
          >取消</v-btn
        >
        <v-btn color="#0BA7A3" dark text @click="confirmEvent()">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AlertView",
  props: {
    visible: Boolean,
    title: String,
    content: String,
    showDate: Boolean,
    showInput: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      width: "60%",
      dates: [
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      ],
      showDateMenu: false,
      shippingDate: "",
      shippingNumber: "",
    };
  },
  created() {
    console.log(`alert view`);
  },
  computed: {
    ...mapGetters(["alertInfo"]),
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    changeDateMenu() {
      const dateArray = Object.keys(this.dates);
      const dateCount = dateArray.length;
      this.showDateMenu = dateCount !== 2;
    },
    confirmEvent() {
      let data = null;
      if (this.alertInfo.showDate) {
        data = this.dates;
      } else if (this.alertInfo.showInput) {
        data = {
          shippingDate: this.shippingDate,
          shippingNumber: this.shippingNumber,
        };
      }
      console.log(
        `confirmEvent ${JSON.stringify(data)} ${this.alertInfo.showDate}`
      );
      this.alertInfo.confirmEvent(data);
    },
  },
};
</script>

<style scoped></style>
